import { render, staticRenderFns } from "./CandidatePortrait.vue?vue&type=template&id=051e452a&scoped=true&"
import script from "./CandidatePortrait.vue?vue&type=script&lang=js&"
export * from "./CandidatePortrait.vue?vue&type=script&lang=js&"
import style0 from "./CandidatePortrait.vue?vue&type=style&index=0&id=051e452a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051e452a",
  null
  
)

export default component.exports